<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="user.email" :name="lodash.startCase($t('jala_users.email'))" :rules="{required: true, email: true, is_not: model.user.role_id === 1 ? model.user.email : false}" v-slot="{ valid, errors }">
      <b-form-group
          class="row my-3"
          label-cols-md="2"
          :label="lodash.startCase($t('jala_users.email')) + '*'"
          label-for="user.email"
          :state="errors[0] ? false : (valid ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            for="user.email"
            name="user.email"
            type="email"
            required
            :state="errors[0] ? false : (valid ? true : null)"
            v-model="model.user.email"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider v-if="$auth.hasInvestorUserRoleId([6])" vid="user.email_verified" :name="lodash.startCase($t('jala_users.email_verified'))" v-slot="{ valid, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          label-for="user.email_verified"
          :state="errors[0] ? false : (valid ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-checkbox
            for="user.email_verified"
            name="user.email_verified"
            :disabled="!model.id && !!model.user.id"
            :state="errors[0] ? false : (valid ? true : null)"
            v-model="model.user.email_verified"
        >&nbsp;&nbsp;{{ lodash.startCase($t('jala_users.email_verified')) }}</b-form-checkbox>
      </b-form-group>
    </validation-provider>

    <template v-if="!(!model.id && !!model.user.id)">
<!--      <b-card-title title-tag="div" class="clearfix">-->
<!--        <slot name="card-header">-->
<!--          <b-card-title>{{ lodash.startCase($t('jala_users.security')) }}</b-card-title>-->
<!--        </slot>-->
<!--      </b-card-title>-->
      <validation-provider vid="user.password" :name="lodash.startCase($t('jala_users.password'))" :rules="{required: !model.user.id, min: 6}" v-slot="{ valid, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.startCase($t('jala_users.password')) + '*'"
            label-for="user.password"
            :state="errors[0] ? false : (!model.user.id && valid ? true : null)"
            :invalid-feedback="errors[0]"
        >
            <input-password
                for="user.password"
                name="user.password"
                required
                :state="errors[0] ? false : (!model.user.id && valid ? true : null)"
                v-model="model.user.password"
            ></input-password>
        </b-form-group>
      </validation-provider>
      <validation-provider vid="user.password_confirmation" :name="lodash.startCase($t('jala_users.password_confirmation'))" :rules="model.user.password ? 'required|confirmed:user.password' : undefined" v-slot="{ valid, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.startCase($t('jala_users.password_confirmation')) + '*'"
            label-for="user.password_confirmation"
            :state="errors[0] ? false : (model.user.password && valid ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <input-password
              for="user.password_confirmation"
              name="user.password_confirmation"
              required
              :state="errors[0] ? false : (model.user.password && valid ? true : null)"
              v-model="model.user.password_confirmation"
          ></input-password>
        </b-form-group>
      </validation-provider>
    </template>
    <hr>
    <validation-provider vid="user.avatar" :name="lodash.startCase($t('jala_users.avatar'))" :rules="avatarRule" v-slot="{ valid, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.startCase($t('jala_users.avatar'))"
          label-for="user.avatar"
          :state="errors[0] ? false : (valid ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <input-image
            name="user.avatar"
            :disabled="!model.id && !!model.user.id"
            :value="typeof model.user['avatar'] === 'string' ? jalaStorageLink(model.user['avatar']) : model.user['avatar']"
            @change="model.user['avatar'] = $event"
        >
        </input-image>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="user.name" :name="lodash.startCase($t('jala_users.name'))" :rules="{ required: model.id || !model.user.id }" v-slot="{ valid, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.startCase($t('jala_users.name')) + '*'"
          label-for="user.name"
          :state="errors[0] ? false : (valid ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            for="user.name"
            type="text"
            autocomplete="false"
            :plaintext="!model.id && !!model.user.id"
            required
            :state="errors[0] ? false : (valid ? true : null)"
            v-model="model.user.name"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="user.phone" :name="lodash.startCase($t('jala_users.phone'))" :rules="{ phone: true }" v-slot="{ valid, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.startCase($t('jala_users.phone'))"
          label-for="user.phone"
          :state="errors[0] ? false : (valid ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            for="user.phone"
            name="user.phone"
            type="tel"
            :plaintext="!model.id && !!model.user.id"
            :state="errors[0] ? false : (valid ? true : null)"
            v-model="model.user.phone"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="state.jala_trade_role" :name="lodash.startCase($t('jala_investor_users.jala_trade_role'))" :rules="{ required: model.id || !model.user.id }" v-slot="{ valid, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.startCase($t('jala_investor_users.jala_trade_role')) + '*'"
          label-for="state.jala_trade_role"
          :state="errors[0] ? false : (valid ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-select
            for="state.jala_trade_role"
            name="state.jala_trade_role"
            :disabled="!$auth.hasInvestorUserRoleId([6])"
            required
            :state="errors[0] ? false : (valid ? true : null)"
            v-model="model.state.jala_trade_role"
            :options="selects.jala_trade_roles"
        >
        </b-form-select>
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';
  import InputImage from "@/components/inputs/avatar"
  import InputPassword from "@/components/inputs/password"

  export default {
    extends: FormModel,
    components: {
      InputImage,
      InputPassword
    },
    data() {
      return {
        model: {
          role_id: 12, // investor_watcher
          ...this.value,
          state: {
            ...(this.value.state || {}),
            jala_trade_role: this.value.role_id === 6 ? 'admin' : ((this.value.state || {}).jala_trade_role || 'admin'),
          },
          user: {
            ...(this.value.user || {}),
          }
        },
        selects: {
          jala_trade_roles: [
            { value: '', text: '-' },
            { value: 'admin', text: this.lodash.startCase(this.$t('jala_investor_users.admin')) },
            { value: 'finance', text: this.lodash.startCase(this.$t('jala_investor_users.finance')) },
            { value: 'field_assistant', text: this.lodash.startCase(this.$t('jala_investor_users.field_assistant')) },
          ]
        },
        debounceFetchUserByEmail: this.lodash.debounce(this.fetchUserByEmail, 250)
      }
    },
    computed: {
      avatarRule() {
        if (!this.model.user.avatar || (typeof this.model.user.avatar === 'string')) return ''
        return 'image'
      }
    },
    watch: {
      'model.user.email'(value) {
        if (this.model.id) return;
        this.debounceFetchUserByEmail(value)
      },
      'model.state.jala_trade_role'(value) {
        if (value === 'admin') this.model.role_id = 6; // investor_admin
        else this.model.role_id = 12; // investor_watcher
      }
    },
    methods: {
      fetchUserByEmail(value) {
        return this.$axios.get('/jala/users', {
          params: {
            all: 1,
            email__in: value || '-',
            doesnt_have: this.model.id && 'investor_user',
            appends: 'avatar_url'
          }
        }).then((response) => {
          const { data: { data } } = response;
          if (data.length) {
            this.model.user = data[0]
          } else if (this.model.user.id) {
            this.model.user = {
              email: this.model.user.email
            }
          }
          return response;
        })
      },
      validateAll() {
        return this.$refs.form.validate().then((isValid) => {
          if (isValid) {
            this.$emit('input', {
              ...this.model,
              user: {
                ...(this.model.user || {}),
                avatar: (typeof this.model.user.avatar === 'string') ? undefined : this.model.user.avatar,
                password: this.model.user.password || undefined
              },
              state: {
                ...(this.model.state || {}),
                jala_trade_role: this.model.state.jala_trade_role !== 'admin' ? this.model.state.jala_trade_role : null
              }
            })
          }
          this.$emit('update:is-valid', isValid)
          this.$emit('update:form-errors', this.$refs.form.errors)
          const field = this.lodash.find(this.$refs.form.fields, (field) => !field.passed);
          if (field) {
            const child = this.$refs.form.$children.find((child) => child.id === field.id);
            child.$el.scrollIntoView({behavior: "smooth"});
          }
          return isValid;
        }).catch(() => false)
      }
    }
  }
</script>
